import type {
  PnlMilestoneDirection,
  PnlMilestoneScope,
  PnlMilestoneType,
} from "../../../../types/milestones";

export const PNL_MILESTONE_SCOPE_OPTIONS: { value: PnlMilestoneScope; label: string }[] = [
  { value: "overall", label: "Overall" },
  { value: "delta", label: "Delta" },
];

export const PNL_MILESTONE_TYPE_OPTIONS: { value: PnlMilestoneType; label: string }[] = [
  { value: "absolute", label: "Absolute" },
  { value: "percent", label: "Percent" },
];

export const PNL_MILESTONE_DIRECTION_OPTIONS: { value: PnlMilestoneDirection; label: string }[] = [
  { value: "up", label: "Up" },
  { value: "down", label: "Down" },
];

export function formatMilestonePercent(v: number): string {
  return `${v.toLocaleString(undefined, { maximumFractionDigits: 2 })}%`;
}

export function clampMilestoneProgress01(x: number): number {
  if (!Number.isFinite(x)) return 0;
  return Math.max(0, Math.min(1, x));
}

export function isMilestoneReached(definition: {
  reached?: boolean | null;
}): boolean {
  return definition.reached === true;
}

/** Scale gradient fill so a partial bar shows the matching slice of the full-track gradient. */
export function milestoneProgressGradientInnerWidthPercent(progressPercent: number): number | undefined {
  if (progressPercent <= 0) return undefined;
  return 10000 / progressPercent;
}

/** Milestone list row content padding inside bordered card shell. */
export const pnlMilestoneRowCardContentClassName = "flex w-full min-w-0 flex-col gap-3 p-4";
